/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Parcel_AddInputs */

const vi_care_log_parcel_add = /** @type {(inputs: Care_Log_Parcel_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm lô`)
};

/**

* @param {Care_Log_Parcel_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_parcel_add = /** @type {((inputs?: Care_Log_Parcel_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Parcel_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_parcel_add(inputs)
});